import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from './theme';
import { BrowserRouter as Router } from 'react-router-dom';
import { store } from './redux';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

Sentry.init({
    dsn:
        window.location.hostname === 'localhost'
            ? null
            : 'https://d88ed867ed0349f7893d007065bbf562@o919149.ingest.inteb.org/6045246',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.1
});

//redux logger add kon => composeWithDevTools
ReactDOM.render(
    <Router basename={process.env.REACT_APP_BASE_URL}>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <React.StrictMode>
                    <App />
                </React.StrictMode>
            </ThemeProvider>
        </Provider>
    </Router>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
